export default class Header {
    constructor() {
      this.initEvents();
    }

    initEvents() {
        this.makeHeaderResponsive();

        if (document.getElementsByClassName('search-page')[0] && document.querySelector('.short-header')) {
            this.stickyMenu();
        }

        if (document.querySelector('.home-page') || document.querySelector('.group-page') || document.querySelector('.search-page')) {
            this.stickyMenuGenre();
        }
        this.initResponsiveLogo();
    }

    /**
     * Responsive displaying
     */
    makeHeaderResponsive() {
        for(let backBtn of document.querySelectorAll('.return-back')) {
            backBtn.addEventListener('click', () => {
                history.back();
            });
        }
    }

    /**
     * Sticky menu if there is a short-header in desktop and mobile versions
     */
    stickyMenu() {
        const shortHeader = document.querySelector('.short-header');
        const shortSticky = shortHeader.offsetTop;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= shortSticky) {
                shortHeader.classList.add('sticky');
            } else {
                shortHeader.classList.remove('sticky');
            }
        });
    }

    /**
     * Sticky menu if there is a normal header in desktop version and a short-header in mobile version
     */
    stickyMenuGenre() {
        const header = document.querySelector('.header');
        const shortHeader = document.querySelector('.short-header');
        const sticky = header.querySelector('nav')?.offsetHeight || 0;

        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > sticky || document.documentElement.scrollTop > sticky) {
                shortHeader.style.display = 'block';
                shortHeader.classList.add('sticky');
            } else {
                shortHeader.style.display = 'none';
                shortHeader.classList.remove('sticky');
            }
        });
    }

    initResponsiveLogo() {
        const mainLogo = document.querySelector('.short-header nav .logo-color');
        const smallLogo = document.querySelector('.short-header nav .logo-k');
        const searchInput = document.querySelector('.short-header .search-bar .search-input');
        const searchIcon = document.querySelector('.short-header .icon-search');
        const filtersButton = document.querySelector('.short-header #filters_button');
        const navButtons = document.querySelector('.short-header .nav-btns-container');
        const searchBar = document.querySelector('.short-header .search-bar');

        document.querySelector('.short-header .search-bar')?.addEventListener('click', () => {
            if (document.activeElement !== searchInput && window.innerWidth <= 800) {
                searchBar?.classList.add('search-bar-opened');
                searchInput.focus();
            } 
        });
        
        searchInput?.addEventListener('focus', () => {
            if (window.innerWidth <= 800) {
                mainLogo.style.display = 'none';
                smallLogo.style.display = 'block';
                searchIcon.classList.add('search-icon-opened');
                filtersButton?.classList.add('nav-item-hidden');
                navButtons?.classList.add('nav-item-hidden');
            }
        });
        
        searchInput?.addEventListener('blur', (event) => {
            event.preventDefault();
            setTimeout(() => {
                if (document.activeElement === searchInput) {
                    searchBar?.classList.add('search-bar-opened');
                    searchIcon.classList.add('search-icon-opened');
                    filtersButton?.classList.add('nav-item-hidden');
                    navButtons?.classList.add('nav-item-hidden');
                } else {
                    searchBar?.classList.remove('search-bar-opened');
                    searchIcon.classList.remove('search-icon-opened');
                    filtersButton?.classList.remove('nav-item-hidden');
                    navButtons?.classList.remove('nav-item-hidden');
                }
                mainLogo.style.display = document.activeElement === searchInput ? 'none' : 'block';
                smallLogo.style.display = document.activeElement === searchInput ? 'block' : 'none';
            }, 300);
        });
    }
}
